/**
 * Copyright Mántum All Rights Reserved.
 */
import Row from './row';
import { sort } from '@mantum/kanela';
import type { Group, Groups } from '../type';

type PropTypes = {
    items: Groups;
    onClick: (value: Group) => void;
    selected?: Group;
};

export default function Sidebar(props: PropTypes) {
    // prettier-ignore
    const { 
        items = []
    } = props;

    return (
        <div className='hidden h-full w-60 overflow-hidden rounded-l-md bg-accent-dark md:block'>
            <ul className='flex h-full flex-col overflow-y-auto py-4'>
                {items.sort(sort.asc).map((group, index) => (
                    <li key={`${group.key}-{${index}}`}>
                        <Row
                            key={group.key}
                            onClick={props.onClick}
                            selected={props.selected}
                            value={group}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}
